import React from 'react'

const MetadataExtractorViewResult = ({result}) => {
  const formatArray = (arr) => {
    if (!arr || arr.length === 0) return '-';
    return Array.isArray(arr) ? arr.join(', ') : arr;
  };

  const formatValue = (value) => {
    if (value === null || value === undefined) return '-';
    if (typeof value === 'object') {
      return Object.entries(value)
        .map(([key, val]) => `${key}: ${val}`)
        .join(', ');
    }
    return value;
  };

  const metadata = result?.extracted_metadata || {};

  return (
    <div className="mt-4 overflow-x-auto">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Document Info & Primary Metadata */}
        <div className="space-y-4">
          <div className="card bg-base-100 shadow-sm">
            <div className="card-body p-4">
              <h3 className="card-title text-lg mb-2">Document Information</h3>
              <table className="table table-zebra w-full">
                <tbody>
                  <tr>
                    <td className="font-medium">Type</td>
                    <td className="capitalize">{formatValue(metadata?.document_info?.type)}</td>
                  </tr>
                  <tr>
                    <td className="font-medium">Category</td>
                    <td className="capitalize">{formatValue(metadata?.document_info?.category)}</td>
                  </tr>
                  <tr>
                    <td className="font-medium">Industry</td>
                    <td className="capitalize">{formatValue(metadata?.document_info?.industry)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="card bg-base-100 shadow-sm">
            <div className="card-body p-4">
              <h3 className="card-title text-lg mb-2">Primary Metadata</h3>
              <table className="table table-zebra w-full">
                <tbody>
                  {Object.entries(metadata?.primary_metadata?.key_value_pairs || {}).map(([key, value]) => (
                    <tr key={key}>
                      <td className="font-medium capitalize">{key.replace(/_/g, ' ')}</td>
                      <td>{formatValue(value)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Entity Metadata & Quality Metrics */}
        <div className="space-y-4">
          <div className="card bg-base-100 shadow-sm">
            <div className="card-body p-4">
              <h3 className="card-title text-lg mb-2">Entity Information</h3>
              <div className="space-y-3">
                {Object.entries(metadata?.entity_metadata || {}).map(([category, data]) => (
                  <div key={category} className="p-2 bg-base-200 rounded-lg">
                    <h4 className="font-medium capitalize mb-2">{category.replace(/_/g, ' ')}</h4>
                    {Object.entries(data).map(([key, values]) => (
                      <div key={key} className="text-sm">
                        <span className="text-base-content/70 capitalize">{key.replace(/_/g, ' ')}: </span>
                        <span>{formatValue(values)}</span>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="card bg-base-100 shadow-sm">
            <div className="card-body p-4">
              <h3 className="card-title text-lg mb-2">Quality Metrics</h3>
              <div className="space-y-3">
                {/* Confidence Scores */}
                <div className="p-2 bg-base-200 rounded-lg">
                  <h4 className="font-medium mb-2">Confidence Scores</h4>
                  <div className="text-sm space-y-1">
                    <div className="flex justify-between">
                      <span>Average:</span>
                      <span className="font-medium">{formatValue(metadata?.quality_metrics?.confidence?.average * 100)}%</span>
                    </div>
                    {Object.entries(metadata?.quality_metrics?.confidence?.by_category || {}).map(([category, score]) => (
                      <div key={category} className="flex justify-between">
                        <span className="capitalize">{category.replace(/_/g, ' ')}:</span>
                        <span>{formatValue(score * 100)}%</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Completeness */}
                <div className="p-2 bg-base-200 rounded-lg">
                  <h4 className="font-medium mb-2">Completeness</h4>
                  <div className="text-sm space-y-1">
                    <div className="flex justify-between">
                      <span>Score:</span>
                      <span>{formatValue(metadata?.quality_metrics?.completeness?.score)}%</span>
                    </div>
                    <div>
                      <span className="text-base-content/70">Missing Fields: </span>
                      <span>{formatValue(metadata?.quality_metrics?.completeness?.missing_fields)}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetadataExtractorViewResult;